<template>
  <div class="contain-list">
    <van-pull-refresh v-model="refreshing" @refresh="messageListRefresh" v-if="messageList.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        success-text="刷新成功"
        @onLoad="handLoad"
        >
     <div class="card" v-for="item in messageList" :key="item.id">
       <div class="card-header">
         <span :class="spanColor(item)" v-if="item.level != 0">【{{ getLevelName(item.level) }}】</span>
         <span class="card-title">{{item.entityTypeTitle}}</span>
       </div>
       <div class="card-content">
         <span>{{item.content}}</span>
         <span class="link" @click="handRoute(item)">请处理></span>
       </div>
       <div class="card-time">
         {{item.createdAt}}
       </div>
     </div>
      </van-list>
    </van-pull-refresh>
    <div class="list-no-data-exists" v-if="messageList.length == 0"><img
      src="@/assets/images/image-no-plans.png" alt=""
      class="image-no-plans">暂无消息
    </div>
  </div>
</template>

<script>
import { List, PullRefresh } from "vant";
    export default {
      components: {
        [List.name]: List,
        [PullRefresh.name]: PullRefresh
      },
      props:{
        messageList:{
          type:Array,
          default:() =>{
            return []
          }
        },
        finished:{
          type:Boolean,
          default:() =>{
            return false
          }
        }
      },
      data(){
        return {
          loading:false,
          refreshing: false,
        }
      },
      mounted() {
        this.getSeeDom()
      },
      methods:{
        // 等级颜色处理
        spanColor(row){
           switch (row.level) {
             case 3:
               return 'red-text'
               break;
             case 2:
               return 'prey-text'
               break;
             case 1:
               return 'green-text'
               break;
             default:
               break;
           }
        },
       // 转换等级名称
        getLevelName(level){
          switch (level){
            case 3:
              return '高'
              break;
            case 2:
              return '中'
              break;
            case 1:
              return '低'
              break;
            default:
              return ''
              break;
          }
        },
       // 跳转到计划列表
        handRoute(item){
          let routeList = JSON.parse(item.customParam)
          this.$router.push({
            path:'/h5-strategy-execution',
            query:{
              strategyId:routeList.strategy_id,
              listId:routeList.account_strategy_id
            }
          })
        },
       // 获取可视区域的DOM
       getSeeDom(){
         let params = {
           userId:String(JSON.parse(localStorage.getItem('h5userInfo')).id),
           messageTargetIds:[]
         }
         this.$apis.getStationMessageReadSetApi(params).then(res =>{
           if(res){
             this.$emit('updateList',true)
           }
         })
       },
       messageListRefresh(){
         this.loading = false
         this.refreshing = false
         this.$emit('refresh',true)
       },
        handLoad(){
        }
      }
    }
</script>

<style scoped lang="less">
   .contain-list{
     padding: 20px;
     .card{
       min-height: 200px;
       border-radius: 10px;
       padding: 10px;
       background: #FFFFFF;
       margin-bottom: 20px;
       .card-header{
         .card-title{
           font-weight: 600;
         }
         .red-text{
           color: #CC0000;
         }
         .prey-text{
           color: #800080;
         }
         .green-text{
           color: #008000;
         }
       }
       .card-content{
         padding-left: 10px;
         padding-top: 10px;
         line-height: 50px;
         .link{
           color: #0000FF;
           padding-left: 20px;
         }
       }
       .card-time{
         color: #CCCCCC;
         padding-left: 10px;
         line-height: 50px;
       }
     }
     .list-no-data-exists {
       display: flex;
       flex-direction: column;
       align-items: center;
       height: 100%;
       font-size: 28px;
       font-weight: 400;
       color: #888888;

       .image-no-plans {
         width: 240px;
         height: 186px;
         margin-top: 226px;
         margin-bottom: 34px;
       }
     }
   }
</style>
